import bgImg from '@/assets/images/img_2.webp'
import Footer from '@/components/Footer'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { Outlet } from 'react-router-dom'
import Compliance from '../Compliance'
import Nav from '../Nav'

const Container = styled(motion.div)`
  /* background-image: url('${bgImg}'); */
  background-color: #f5f5f5;
`
const Center = styled(motion.div)``
const Left = styled(motion.div)``
const Right = styled(motion.div)`
  /* box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px; */
`

export default function Index() {
  return (
    <Container className="w-screen min-h-screen">
      <Nav />
      <Outlet />
      <Footer />
      <Compliance />
    </Container>
  )
}
